import Typography from "./components/Typography/Typography.tsx";
import ThemePicker from "./components/ThemePicker/ThemePicker.tsx";
import PageReorder from "./components/PageReorder/PageReorder.tsx";
import Elements from "./components/Elements/Elements.tsx";
import LogoUpload from "./components/LogoUploader/LogoUploader.tsx";
import ContactInformationCard from "./components/ContactInformationCard/ContactInformationCard.tsx";
import Layout from "./components/Layout/Layout.tsx";
import ReportSections from "./components/ReportSections/ReportSections.tsx";
import Appendix from "./components/Appendix/Appendix.tsx";
import NoteSection from "../DocxTemplateWidget/components/NoteSection/NoteSection";

export default function PdfTemplateWidget() {
  return (
    <>
      <NoteSection />
      <PageReorder />
      <ReportSections />
      <ThemePicker />
      <Typography />
      <ContactInformationCard />
      <Appendix />
      <LogoUpload />
      <Layout />
      <Elements />
    </>
  );
}
